import { z } from 'zod';

export const DataSyncExternalRecordTypeSchema = z.enum(['LucityWorkRequest','SimplicityServiceRequest','AssetEssentialsWorkOrder','EnergovCodeCase','PeregrineRequest','CityViewCodeRequest','EdgesoftWorkOrder','AccelaRecord','CityWorksServiceRequest','OpenGovWorkRequest','InforServiceRequest','MunicityComplaint','LaserficheEntry']);

export type DataSyncExternalRecordTypeType = `${z.infer<typeof DataSyncExternalRecordTypeSchema>}`

export default DataSyncExternalRecordTypeSchema;
